const logoPath =
    'M210.59,149.74L127.36,41.4c-.78-1.01-2.3-1.01-3.08,0l-16.04,20.87c-.72.93-.45,2.28.57,2.86l16.04,9.27c.6.35.97.99.97,1.68v24.03c0,.75-.81,1.21-1.46.84l-30.28-17.49c-.84-.49-1.92-.27-2.51.5l-16.54,21.54c-.71.93-.45,2.28.57,2.86l49.25,28.44c.6.35.97.99.97,1.68v25.5c0,.75-.81,1.21-1.46.84l-64.26-37.13c-.84-.49-1.92-.27-2.51.5l-16.54,21.54c-.71.93-.45,2.28.57,2.86l82.26,47.48c1.2.69,2.68.69,3.88,0l82.26-47.48c1.02-.59,1.28-1.93.57-2.86Z';

export function AppLogo() {
    return (
        <div className="fixed inset-0 flex items-center justify-center z-[9999] pointer-events-none">
            <svg
                width="175"
                height="168"
                viewBox="0 0 251.64 241.25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                    animation: 'logo-breathe 5.5s ease-in-out infinite',
                }}
            >
                <path fill="#252628" d={logoPath} />
            </svg>
        </div>
    );
}
